import axios from "axios"
import { useDefaultAttachmentsApiForControllerRoute } from "."

export function usePersonAttachmentApi() {
  const defaultAPI = useDefaultAttachmentsApiForControllerRoute("persons")

  return {
    ...defaultAPI,
    getProfilePictureUrlForPerson: function (
      personId: number,
      size?: number | undefined
    ) {
      return `${defaultAPI.baseUrl}/get-profile-picture?personId=${personId}${
        size ? "&thumbnailSize=" + size : ""
      }`
    },
    addProfilePictureForPerson: function (file: File, personId: number) {
      const formData = new FormData()
      formData.append("file", file, file.name)

      return axios.post(
        `${defaultAPI.baseUrl}/set-profile-picture?personId=${personId}`,
        formData
      )
    },
  }
}
